// Library imports
import React from "react";
import ReactDOM from "react-dom/client";

// Application components
import App from "./App";

// Styles
import "./index.css";

document.documentElement.classList.add("dark");

// Get root element and validate its existence
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find root element");
}

// Cross-surface providers live in the root route (`__root.tsx`); auth/session and the
// dashboard sidebar are mounted per-surface so public marketing pages stay provider-light.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
